import ChartWidget from './ChartWidget.vue';
import ComponentWidget from './ComponentWidget.vue';
import KpiWidget from './KpiWidget.vue';
import TableWidget from './TableWidget.vue';
import TextWidget from './TextWidget.vue';
import HeadingWidget from './HeadingWidget.vue';
import SheetWidget from './SheetWidget.vue';

function component(componentName, needsMetric = true) {
  return { name: `${componentName}Widget`, extends: ComponentWidget, componentName, needsMetric };
}

export const STOCK_WIDGETS = {
  chart: ChartWidget,
  kpi: KpiWidget,
  table: TableWidget,
  text: TextWidget,
  heading: HeadingWidget,
  sheet: SheetWidget,
  'performance-trend': component('PerformanceTrend'),
  'peer-comparison': component('PerformanceCohort'),
  'performance-summary': component('PerformanceSummary', false),
  'metric-alerts': component('ComposableAlertTable'),
  'metric-insights': component('MetricInsights'),
  'patient-worklist': component('PatientWorklist'),
  'ai-insights': component('AIInsights', false),
  'platform-component': component('', false),
};

export function stockComponent(name) {
  return STOCK_WIDGETS[name] || null;
}
